import { CommonResponse } from "api/api.types"
import { snakelize, camelize } from "../../../helpers/object"
import { DeleteProductRequestParams, GetProductsRequestParams, GetProductsResponse } from "./product.types"

export default ($axios: any): any => ({
  async getProductsV2({
    brandID,
    brandToken,
    orderBy,
    filterNotSelected,
    filterNotDeployed,
    isCampaignCompleted,
    page,
    size,
  }: {
    brandID: number;
    brandToken: string;
    orderBy?: string;
    filterNotSelected?: boolean;
    filterNotDeployed?: boolean;
    isCampaignCompleted?: boolean;
    page?: number;
    size?: number;
  }) {
    return camelize(await $axios.get(`/v2/brands/${brandID}/products`, { params: snakelize({
      brandToken,
      ...(orderBy ? { orderBy } : {}),
      ...(filterNotSelected ? { filterNotSelected } : {}),
      ...(filterNotDeployed ? { filterNotDeployed } : {}),
      ...(isCampaignCompleted ? { isCampaignCompleted } : {}),
      ...(page ? { page } : {}),
      ...(size ? { size } : {}),
    }) }));
  },

  /**
   * 제품 목록 조회 API
   */
  async getProducts(data?: GetProductsRequestParams): Promise<GetProductsResponse> {
    return camelize(await $axios.get(`/product`, { params: snakelize(data) }))
  },

  // 제품 삭제
  async deleteProduct(data?: DeleteProductRequestParams): Promise<CommonResponse> {
    return camelize(await $axios.delete(`/product/${data.id}`, snakelize({ data })))
  },

  /**
   * 제품 리스트
   * @deprecated
   */
  async index(data: any) {
    return camelize(await $axios.get(`/product`, { params: snakelize(data) }))
  },

  // 제품 master 조회
  async show(data: any) {
    return camelize(await $axios.get(`/product/${data.id}`, { params: snakelize(data) }))
  },

  // 제품 product 조회
  async showProduct(data: any) {
    return camelize(
      await $axios.get("/product/product_view", {
        params: snakelize(data),
      })
    )
  },

  // 제품 필터별 총 갯수 조회
  async counts(data: any) {
    return camelize(
      await $axios.get("/product/counts", {
        params: snakelize(data),
      })
    )
  },

  // 제품 생성
  async store(data: any) {
    return camelize(await $axios.post("/product", snakelize(data)))
  },

  // 제품 등록 접수
  async register(data: any) {
    return camelize(await $axios.post(`/product/${data.id}/register`, snakelize(data)))
  },

  // 제품 반납 요청
  async return(data: any) {
    return camelize(await $axios.post(`/product/${data.id}/return`, snakelize(data)))
  },

  async update(data: any) {
    return camelize(await $axios.patch(`/product/${data.id}`, snakelize(data)))
  },

  async updateMaster(data: any) {
    return camelize(await $axios.patch(`/product-master/${data.id}`, snakelize(data)))
  },

  // 이미지 업로드
  async uploadImage(data?: any) {
    const formData = new FormData()
    formData.append("image", data.image)
    formData.append("brand_token", data.brandToken)

    return camelize(await $axios.post("/product/image/upload", formData))
  },

  async delete(data?: any) {
    await $axios.delete(`/product/${data.id}`, snakelize({ data: data }))
  },

  async deleteImage(data?: any) {
    return await $axios.delete(`/product/image/${data.url}`, snakelize({ data: data }))
  },

  async rules(data?: any) {
    return camelize(await $axios.get(`/product/${data.id}/rules`, snakelize({ params: data })))
  },

  async createRules(data?: any) {
    return camelize(await $axios.get(`/product/rules/create`, snakelize({ params: data })))
  },
})
